import { render, staticRenderFns } from "./AddResponseBillingCode.vue?vue&type=template&id=229d5d6d&"
import script from "./AddResponseBillingCode.vue?vue&type=script&lang=js&"
export * from "./AddResponseBillingCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports